import { DELETE_DMX_UNIVERSE, DELETE_DMX_UNIVERSE_SUCCESSFUL, DELETE_DMX_UNIVERSE_FAILED } from './actionTypes';

const initialState = {
  deleteDmxUniverseError: null,
  messageDmxUniverse: null,
  loadingDeleteDmxUniverse: false,
};

const deleteUniverse = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_DMX_UNIVERSE:
      state = { ...state, loadingDeleteDmxUniverse: true, deleteDmxUniverseError: null };
      break;
    case DELETE_DMX_UNIVERSE_SUCCESSFUL:
      state = { ...state, loadingDeleteDmxUniverse: false, messageDmxUniverse: action.payload, deleteDmxUniverseError: null };
      break;
    case DELETE_DMX_UNIVERSE_FAILED:
      state = { ...state, messageDmxUniverse: null, loadingDeleteDmxUniverse: false, deleteDmxUniverseError: action.payload };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default deleteUniverse;
